import "@babel/polyfill";
import { humburger_menu } from "./modules/humburger-menu";
import { anchor_link } from "./modules/anchor-link";
import { anchor_current } from "./modules/anchor-current";
import { window_size, viewport_less } from "./modules/theme";
import { ScrollTop } from "./modules/scroll-top";
import { tab_menus, tabs } from "./modules/tab-menu";
import { modal } from "./modules/modal";
import { cardSwiper, cardSwiperSize, mvSwiper, slideSwiper, slideSwiperQuick } from "./modules/swiper";
import { fsSearchItemColor, fsSearchItemPrice} from "./modules/saerch-item";
import { fetch_information, fetch_journal, fetch_voice, fetch_data_album, fetch_data_blog, fetch_data_example, fetch_data_hanaokuri, fetch_data_info, fetch_data_journal, fetch_data_voice, fetch_data_d, fetch_data_faq, fetch_data_faq_contents } from "./modules/data-fetch";
import { toc } from "./modules/toc";
import { global_menu } from "./modules/global-menu";
import { group_mv } from "./modules/mv";

// window size write to html tag
window_size();
viewport_less();

// humburger menu
humburger_menu();

// global menu
document.addEventListener('DOMContentLoaded', () => {
  global_menu();
});

// document.addEventListener('DOMContentLoaded', () => {
//   global_menu(); // 初期ページ表示時

//   document.body.addEventListener('htmx:afterSwap', (e) => {
//     if (e.target.matches('.l-header') || e.detail.target.matches('.l-header')) {
//       // console.log('[HTMX] ヘッダー再初期化');
//       global_menu();
//     }
//   });
// });

// Scroll Top
ScrollTop();

// modal
modal();

// anchor link fix
// anchor_link();
// anchor_current();

// image map
// rwd_image_maps();

// loading use sessionStorage
// loading();

// tab menu
// tab_menus();
tabs();

// swiper
cardSwiper();
cardSwiperSize();
mvSwiper();
slideSwiper();
slideSwiperQuick();

// futureshop
fsSearchItemColor();
fsSearchItemPrice();

// wp rest api
fetch_information();
fetch_journal();
fetch_voice();

// wp rest api custom endpoint
fetch_data_album();
fetch_data_blog();
fetch_data_example();
fetch_data_hanaokuri();
fetch_data_info();
fetch_data_journal();
fetch_data_voice();
fetch_data_faq();
fetch_data_faq_contents();

fetch_data_d();

// Table of Contents
toc();

// Group MV
// group_mv();
